import {
  SET_CART_ERROR,
  UPDATE_CART,
  ADD_CART_ITEM,
  MODIFY_ITEM_QUANTITY,
  SET_CART_LOADING,
} from '../actions/cart';
import { WAREHOUSE_SELECTED } from '../actions/warehouse-action-types';

export const initialState = {
  totalPrice: 0,
  itemQuantitiesById: {},
  items: [],
  transactionRules: [],
  error: null,
  loading: false,
};

function cart(state = initialState, action) {
  switch (action.type) {
    case SET_CART_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case ADD_CART_ITEM:
      return {
        ...state,
        itemQuantitiesById: {
          ...state.itemQuantitiesById,
          [action.id]: (state.itemQuantitiesById[action.id] || 0) + 1,
        },
      };
    case MODIFY_ITEM_QUANTITY:
      return {
        ...state,
        itemQuantitiesById: { ...state.itemQuantitiesById, [action.id]: action.quantity },
      };
    case WAREHOUSE_SELECTED:
      return initialState;
    case SET_CART_ERROR:
      return { ...state, error: action.error };
    case UPDATE_CART:
      return { ...state, ...action.cartData, loading: false };
    default:
      return state;
  }
}

export default cart;
